define("tmds/geometry/mathUtils", [

], function() {
	
	/**
	 * check if the given three points are listed in a counterclosewise order
	 * If the slope of the line AB is less than the slope of the line AC then the three points are listed in a counterclockwise order.
	 * @param A {Object} in format of {x,y}
	 * @param B {Object} in format of {x,y}
	 * @param C {Object} in format of {x,y}
	 * @return {Boolean}
	 * @see http://bryceboe.com/2006/10/23/line-segment-intersection-algorithm/
	 */
	function _ccw(A, B, C) {
		return (C.y - A.y) * (B.x - A.x) > (B.y - A.y) * (C.x - A.x);
	}

	/**
	 * check if a point is on the line segment
	 * @param line {Object} in format of {x1,y1,x2,y2}
	 * @param pnt {Object} in format of {x,y}
	 * @return {Boolean}
	 */
	function _lineContainsPoint(line, pnt) {
		var isOneEnd = (pnt.x === line.x1 && pnt.y === line.y1) || (pnt.x === line.x2 && pnt.y === line.y2);
		var isOnLine = (pnt.y - line.y1) / (pnt.x - line.x1) === (line.y2 - pnt.y) / (line.x2 - pnt.x) && 
						pnt.x <= Math.max(line.x1, line.x2) && pnt.x >= Math.min(line.x1, line.x2) &&
						pnt.y <= Math.max(line.y1, line.y2) && pnt.y >= Math.min(line.y1, line.y2);
		
		return isOneEnd || isOnLine;
	}
	
	/**
	 * check if two line segments intersect
	 * @param line1 {Object} in format of {x1,y1,x2,y2}
	 * @param line2 {Object} in format of {x1,y1,x2,y2}
	 * @return {Boolean} true if intersect.
	 */
	function _lineIntersectsLine(line1, line2) {
		var p1 = {x: line1.x1, y: line1.y1},
			p2 = {x: line1.x2, y: line1.y2},
			inP1 = {x: line2.x1, y: line2.y1},
			inP2 = {x: line2.x2, y: line2.y2};
			
		return (_lineContainsPoint(line1, inP1) || _lineContainsPoint(line1, inP2) || 
				_lineContainsPoint(line2, p1) || _lineContainsPoint(line2, p2)) || 
				(_ccw(p1, inP1, inP2) !== _ccw(p2, inP1, inP2) && _ccw(p1, p2, inP1) !== _ccw(p1, p2, inP2));				
	}
	
	return {
		'lineContainsPoint' : _lineContainsPoint,
		'lineIntersectsLine' : _lineIntersectsLine
	};
});